import './ProviderDataStyle.css';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export default function DTU10() {
  return (
    <>
      <div className="dialogSummary">
        DTU10 (Cheng and Andersen, 2010) is a state-of-art global tide model derived from many years
        of satellite altimetry and tide gauge station data around the world. It is a data-derived
        model providing tidal constituents to predict astronomical tide levels in any point of the
        ocean at any given time.
      </div>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              General
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>DTU10 Global Ocean Tide Model</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Coverage</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Sea water levels and Currents</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Source Name</TableCell>
            <TableCell>Tidal model, TPXO8-DTU10</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publisher</TableCell>
            <TableCell>DTU Space (Technical University of Denmark)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Product type</TableCell>
            <TableCell>Grid</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Cost (ex. VAT)</TableCell>
            <TableCell>Free</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Typical Applications</TableCell>
            <TableCell>Hydrodynamic, wave, Offshore and Marine projects</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>References</TableCell>
            <TableCell>
              <a href="https://www.space.dtu.dk/english" target="_blank" rel="noopener noreferrer">
                DTU Space home
              </a>
              <br />
              <a
                href="https://www.space.dtu.dk/english/research/scientific_data_and_models/global-ocean-tide-model"
                target="_blank"
                rel="noopener noreferrer">
                Global Ocean Tide Model (dtu.dk)
              </a>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Coverage
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Geographical Range</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Resolution</TableCell>
            <TableCell>
              Tidal wave constituents; global resolution for tide and current prediction: <br />
              Water level : 0.125 deg.
              <br />
              Currents : 0.25 deg.
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Reference</TableCell>
            <TableCell>Sea surface</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Reference</TableCell>
            <TableCell>UTC</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Range</TableCell>
            <TableCell>Unlimited</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Resolution</TableCell>
            <TableCell>Flexible</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Variables
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>
            <TableCell>
              Sea water level [m]
              <br />
              East Current velocity [m/s]
              <br />
              North Current velocity [m/s]
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Credits
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Authors</TableCell>
            <TableCell>
              Yongcun Cheng, Ole Baltazar Andersen, (2010). Improvement in global ocean tide model
              in shallow water regions. Poster, SV.1-68 45, OSTST, Lisbon, Oct.18-22.
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}
